export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any; }
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  province: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AddressModel = {
  __typename?: 'AddressModel';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
};

export type ClientModel = {
  __typename?: 'ClientModel';
  contacts: Array<RelatedContactModel>;
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type ContactModel = {
  __typename?: 'ContactModel';
  address: AddressModel;
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum ContactRelationshipType {
  Billing = 'Billing',
  Primary = 'Primary',
  Technical = 'Technical',
  Unspecified = 'Unspecified'
}

export type CreateClientInput = {
  contacts?: InputMaybe<Array<CreateRelatedContactInput>>;
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactInput = {
  address: AddressInput;
  email: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CreatePaymentInput = {
  amount: Scalars['Float']['input'];
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  /** If true, the PO will be closed as paid in full */
  paidInFull?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrderId: Scalars['Int']['input'];
};

export type CreateProjectInput = {
  clientId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreatePurchaseOrderInput = {
  amount: Scalars['Float']['input'];
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  dateEstimatedShipment?: InputMaybe<Scalars['DateTime']['input']>;
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  dateRequestedShipment?: InputMaybe<Scalars['DateTime']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['Int']['input'];
  status?: InputMaybe<PurchaseOrderStatus>;
};

export type CreateQuoteInput = {
  amount: Scalars['Float']['input'];
  dateSent?: InputMaybe<Scalars['DateTime']['input']>;
  designFirm?: InputMaybe<Scalars['String']['input']>;
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  rfqId: Scalars['Int']['input'];
};

export type CreateRelatedContactInput = {
  contactId: Scalars['Float']['input'];
  contactType: ContactRelationshipType;
};

export type CreateRfqInput = {
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  vendorId: Scalars['Int']['input'];
};

export type CreateVendorInput = {
  address: AddressInput;
  /** Commission rate as a percentage. Used as the default for all POs for this vendor. */
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  contacts?: InputMaybe<Array<CreateRelatedContactInput>>;
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVendorPaymentInput = {
  amount: Scalars['Float']['input'];
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId: Scalars['Int']['input'];
};

export type ImportFromFileInput = {
  storagePath: Scalars['String']['input'];
};

export type ImportFromTemplateResponse = {
  __typename?: 'ImportFromTemplateResponse';
  clients: ImportSummaryCounts;
  orders: ImportSummaryCounts;
  vendors: ImportSummaryCounts;
};

export type ImportSummaryCounts = {
  __typename?: 'ImportSummaryCounts';
  created: Scalars['Float']['output'];
  errors: Array<Scalars['String']['output']>;
  skipped: Scalars['Float']['output'];
};

export type ListPaymentsFilterInput = {
  dateCreatedMax?: InputMaybe<Scalars['DateTime']['input']>;
  dateCreatedMin?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListRfqsFilterInput = {
  dateCreatedMax?: InputMaybe<Scalars['DateTime']['input']>;
  dateCreatedMin?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<RfqStatus>>;
};

export type MiscPaymentModel = {
  __typename?: 'MiscPaymentModel';
  amount: Scalars['Float']['output'];
  createdById: Scalars['Int']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  vendorId: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AcceptInvitation: Scalars['Boolean']['output'];
  ClosePurchaseOrder: PurchaseOrderModel;
  CloseQuote: QuoteModel;
  CreateClient: ClientModel;
  CreateContact: ContactModel;
  CreateOrganization: OrganizationModel;
  CreatePayment: PaymentModel;
  /** Create multiple payments */
  CreatePayments: Scalars['Int']['output'];
  /** Create a new project */
  CreateProject: ProjectModel;
  CreatePurchaseOrder: PurchaseOrderModel;
  CreateQuote: QuoteModel;
  CreateRfq: RfqModel;
  CreateVendor: VendorModel;
  /** Delete a client */
  DeleteClient: ClientModel;
  DeleteContact: ContactModel;
  /** Delete a payment. Returns the deleted payment. */
  DeletePayment: PaymentModel;
  /** Delete a project */
  DeleteProject: ProjectModel;
  DeleteQuote: QuoteModel;
  DeleteRfq: RfqModel;
  DeleteVendor: VendorModel;
  ImportFromFile: ImportFromTemplateResponse;
  ImportTestFile: ImportFromTemplateResponse;
  InviteUserToOrganization: Scalars['Boolean']['output'];
  RemoveUserFromOrganization: Scalars['Boolean']['output'];
  ReopenPurchaseOrder: PurchaseOrderModel;
  SignedUploadUrl: SignedUploadResponse;
  /** Update a client */
  UpdateClient: ClientModel;
  UpdateContact: ContactModel;
  UpdateOrganization: OrganizationModel;
  UpdatePayment: PaymentModel;
  /** Update a project */
  UpdateProject: ProjectModel;
  UpdatePurchaseOrder: PurchaseOrderModel;
  UpdateQuote: QuoteModel;
  UpdateRfq: RfqModel;
  UpdateVendor: VendorModel;
};


export type MutationAcceptInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationClosePurchaseOrderArgs = {
  closureReason?: InputMaybe<PurchaseOrderClosureReason>;
  id: Scalars['Int']['input'];
};


export type MutationCloseQuoteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePaymentsArgs = {
  payments: Array<CreatePaymentInput>;
  vendorPayments: Array<CreateVendorPaymentInput>;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreatePurchaseOrderArgs = {
  input: CreatePurchaseOrderInput;
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};


export type MutationCreateRfqArgs = {
  input: CreateRfqInput;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationDeleteClientArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteContactArgs = {
  input: Scalars['Int']['input'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteQuoteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRfqArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteVendorArgs = {
  input: Scalars['Float']['input'];
};


export type MutationImportFromFileArgs = {
  input: ImportFromFileInput;
};


export type MutationInviteUserToOrganizationArgs = {
  inviteeEmail: Scalars['String']['input'];
  role: Role;
};


export type MutationRemoveUserFromOrganizationArgs = {
  userId: Scalars['Float']['input'];
};


export type MutationReopenPurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSignedUploadUrlArgs = {
  input: SignedUrlUploadRequest;
};


export type MutationUpdateClientArgs = {
  id: Scalars['Int']['input'];
  input: UpdateClientInput;
};


export type MutationUpdateContactArgs = {
  id: Scalars['Int']['input'];
  input: UpdateContactInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrgInput;
};


export type MutationUpdatePaymentArgs = {
  id: Scalars['Int']['input'];
  input: UpdatePaymentInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['Int']['input'];
  input: UpdateProjectInput;
};


export type MutationUpdatePurchaseOrderArgs = {
  id: Scalars['Int']['input'];
  input: UpdatePurchaseOrderInput;
};


export type MutationUpdateQuoteArgs = {
  id: Scalars['Int']['input'];
  input: UpdateQuoteInput;
};


export type MutationUpdateRfqArgs = {
  id: Scalars['Int']['input'];
  input: UpdateRfqInput;
};


export type MutationUpdateVendorArgs = {
  id: Scalars['Float']['input'];
  input: UpdateVendorInput;
};

export type OrgInvitationModel = {
  __typename?: 'OrgInvitationModel';
  dateAccepted?: Maybe<Scalars['DateTime']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  invitedById: Scalars['Float']['output'];
  organizationId: Scalars['String']['output'];
  role: Role;
};

export type OrgMembershipModel = {
  __typename?: 'OrgMembershipModel';
  /** The organization id */
  id: Scalars['String']['output'];
  /** The organization name */
  name: Scalars['String']['output'];
  /** The user role in the organization */
  role: Role;
};

export type OrganizationModel = {
  __typename?: 'OrganizationModel';
  clientCount: Scalars['Float']['output'];
  date_created: Scalars['DateTime']['output'];
  date_modified: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectCount: Scalars['Float']['output'];
  quoteCount?: Maybe<Scalars['Int']['output']>;
  userCount: Scalars['Float']['output'];
  vendorCount: Scalars['Float']['output'];
};

export type PartialAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentModel = {
  __typename?: 'PaymentModel';
  amount: Scalars['Float']['output'];
  createdById: Scalars['Int']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  project: ProjectModel;
  purchaseOrderId: Scalars['Int']['output'];
  vendor: VendorModel;
};

/**
 * A project is a collection of invoices, POs, and other documents.
 * Projects contain (but are not limited to):
 *
 *   - Quotes
 *   - Invoices
 *   - Purchase Orders
 *   - Sales Orders
 */
export type ProjectModel = {
  __typename?: 'ProjectModel';
  client: ClientModel;
  client_id: Scalars['Float']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  incomePotential: Scalars['USCurrency']['output'];
  name: Scalars['String']['output'];
  outstandingCommission: Scalars['USCurrency']['output'];
  rfqs: Array<RfqModel>;
  totalPaymentsReceived: Scalars['USCurrency']['output'];
  vendors: Array<VendorModel>;
};

export enum PurchaseOrderClosureReason {
  None = 'None',
  PaidInFull = 'PaidInFull'
}

export type PurchaseOrderModel = {
  __typename?: 'PurchaseOrderModel';
  /** The total amount of the purchase order in USD */
  amount: Scalars['Float']['output'];
  closedBy?: Maybe<UserModel>;
  /** The user who closed the purchase order */
  closedById?: Maybe<Scalars['Int']['output']>;
  /** The percentage commission */
  commissionPercentage: Scalars['Float']['output'];
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserModel>;
  createdById: Scalars['Int']['output'];
  /** The date the purchase order was closed. Usually when all due payment has been received */
  dateClosed?: Maybe<Scalars['DateTime']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  /** The estimated shipping date */
  dateEstimatedShipment?: Maybe<Scalars['DateTime']['output']>;
  dateModified: Scalars['DateTime']['output'];
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  /** The requested shipping date */
  dateRequestedShipment?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** The sum of all POs less received payments */
  outstandingCommission: Scalars['Float']['output'];
  payments: Array<PaymentModel>;
  /** The purchase order reference number in the client's system */
  poNumber?: Maybe<Scalars['String']['output']>;
  quote: QuoteModel;
  quoteId: Scalars['Int']['output'];
  status: PurchaseOrderStatus;
  /** The sum of all payments received for this purchase order */
  totalReceived: Scalars['Float']['output'];
};

/** Status of a purchase order */
export enum PurchaseOrderStatus {
  Delivered = 'Delivered',
  New = 'New',
  Shipped = 'Shipped',
  Submitted = 'Submitted'
}

export type Query = {
  __typename?: 'Query';
  Client: ClientModel;
  Clients: Array<ClientModel>;
  Contact: ContactModel;
  Contacts: Array<ContactModel>;
  OrgUserInvitations: Array<OrgInvitationModel>;
  OrgUsers: Array<UserModel>;
  Organization: OrganizationModel;
  /** The sum of all outstanding commissions for the entire org */
  OutstandingCommission: Scalars['USCurrency']['output'];
  Payment: PaymentModel;
  Payments: Array<PaymentModel>;
  /** Get a project by id */
  Project: ProjectModel;
  /** List all projects */
  Projects: Array<ProjectModel>;
  PurchaseOrder: PurchaseOrderModel;
  PurchaseOrders: Array<PurchaseOrderModel>;
  Quote: QuoteModel;
  Quotes: Array<QuoteModel>;
  Rfq: RfqModel;
  Rfqs: Array<RfqModel>;
  User: UserModel;
  Vendor: VendorModel;
  Vendors: Array<VendorModel>;
};


export type QueryClientArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactArgs = {
  id: Scalars['Float']['input'];
};


export type QueryPaymentsArgs = {
  filters?: InputMaybe<ListPaymentsFilterInput>;
};


export type QueryProjectArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRfqArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRfqsArgs = {
  filters?: InputMaybe<ListRfqsFilterInput>;
};


export type QueryVendorArgs = {
  id: Scalars['Int']['input'];
};

/** A quote is the second step in the sales process */
export type QuoteModel = {
  __typename?: 'QuoteModel';
  amount: Scalars['Float']['output'];
  client: ClientModel;
  closedById?: Maybe<Scalars['Int']['output']>;
  createdById: Scalars['Int']['output'];
  dateClosed?: Maybe<Scalars['DateTime']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  dateSent?: Maybe<Scalars['DateTime']['output']>;
  designFirm?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  project: ProjectModel;
  purchaseOrder?: Maybe<PurchaseOrderModel>;
  quoteNumber?: Maybe<Scalars['String']['output']>;
  rfq: RfqModel;
  rfqId: Scalars['Int']['output'];
  vendor: VendorModel;
};

export type RelatedContactModel = {
  __typename?: 'RelatedContactModel';
  contact: ContactModel;
  id: Scalars['Float']['output'];
  relationshipType: ContactRelationshipType;
};

/** A rfq is the initial step in the sales process. */
export type RfqModel = {
  __typename?: 'RfqModel';
  client: ClientModel;
  createdById: Scalars['Int']['output'];
  dateClosed?: Maybe<Scalars['DateTime']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  project: ProjectModel;
  projectId: Scalars['Int']['output'];
  quote?: Maybe<QuoteModel>;
  status: RfqStatus;
  vendor: VendorModel;
  vendorId: Scalars['Int']['output'];
};

export enum RfqStatus {
  Closed = 'CLOSED',
  New = 'NEW',
  Paid = 'PAID',
  PaidInFull = 'PAID_IN_FULL',
  Purchased = 'PURCHASED',
  Quoted = 'QUOTED'
}

export enum Role {
  Admin = 'Admin',
  Owner = 'Owner',
  User = 'User'
}

export type SignedUploadResponse = {
  __typename?: 'SignedUploadResponse';
  filepath: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SignedUrlUploadRequest = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type UpdateClientInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInput = {
  address?: InputMaybe<PartialAddress>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrgInput = {
  name: Scalars['String']['input'];
};

export type UpdatePaymentInput = {
  amount: Scalars['Float']['input'];
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  /** If true, the PO will be closed as paid in full */
  paidInFull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProjectInput = {
  name: Scalars['String']['input'];
};

export type UpdatePurchaseOrderInput = {
  amount: Scalars['Float']['input'];
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  dateEstimatedShipment?: InputMaybe<Scalars['DateTime']['input']>;
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  dateRequestedShipment?: InputMaybe<Scalars['DateTime']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PurchaseOrderStatus>;
};

export type UpdateQuoteInput = {
  amount: Scalars['Float']['input'];
  dateSent?: InputMaybe<Scalars['DateTime']['input']>;
  designFirm?: InputMaybe<Scalars['String']['input']>;
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRfqInput = {
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorInput = {
  address?: InputMaybe<PartialAddress>;
  /** Commission rate as a percentage. Used as the default for all POs for this vendor. */
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserModel = {
  __typename?: 'UserModel';
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  invitations: Array<OrgInvitationModel>;
  orgs: Array<OrgMembershipModel>;
};

export type VendorModel = {
  __typename?: 'VendorModel';
  address: AddressModel;
  categories: Array<Scalars['String']['output']>;
  /** Commission rate as a percentage. Used as the default for all POs for this vendor. */
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  contacts: Array<RelatedContactModel>;
  dateCreated: Scalars['DateTime']['output'];
  dateModified: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  outstandingCommission: Scalars['USCurrency']['output'];
  payments: Array<MiscPaymentModel>;
  website?: Maybe<Scalars['String']['output']>;
};
